import Bullet from 'components/Bullet';
import MentorshipStatusChip from 'components/Chips/MentorshipStatusChip';
import { PageHeadContainer } from 'components/PageHead';
import ProfileNavigation from 'components/profileNavigation';
import ProfileLink from 'components/profileNavigation/Link';
import React, { FC, useContext, useMemo } from 'react';
import useSWR from 'swr';
import Mentorship from 'types/Mentorship';
import MenteeNotifications from 'types/notifications/MenteeNotifications';
import { PageTitle } from '../sign-chart';
import MentorshipManagementRoutes from './Routes';

const Head: FC = () => {
  const { mentorship } = useContext(MentorshipManagementContext);
  return (
    <PageHeadContainer>
      <PageTitle>
        <h1>Votre mentorat</h1>
        {mentorship?.status && (
          <MentorshipStatusChip variant="mentee" status={mentorship.status} />
        )}
      </PageTitle>
    </PageHeadContainer>
  );
};

type ContextType = {
  mentorship: Mentorship | undefined;
  error: unknown | undefined;
};
export const MentorshipManagementContext = React.createContext(
  {} as ContextType,
);
const { Provider } = MentorshipManagementContext;

const MentorshipManagement: FC = ({ children }) => {
  const { data: mentorship, error } = useSWR<Mentorship>('/mentorship/mentee');

  const value: ContextType = useMemo(
    () => ({
      mentorship,
      error,
    }),
    [mentorship, error],
  );

  return <Provider value={value}>{children}</Provider>;
};

const baseURL = '/mentee/mentorship/management/';
const Navigation: FC = () => {
  const { mentorship } = useContext(MentorshipManagementContext);
  const { data: menteeNotifications } = useSWR<MenteeNotifications>(
    '/user/notification/mentee',
  );
  return (
    <ProfileNavigation>
      <ProfileLink to={baseURL}>Mentorat</ProfileLink>
      {mentorship && mentorship.status !== 'FINISHED_ADMIN' && (
        <ProfileLink to={baseURL + 'interviews'}>
          Entretiens programmés
          {menteeNotifications?.interviewNotification && <Bullet />}
        </ProfileLink>
      )}
    </ProfileNavigation>
  );
};

const Usage: FC = (props) => {
  return (
    <MentorshipManagement {...props}>
      <Head />
      <Navigation />
      <MentorshipManagementRoutes />
    </MentorshipManagement>
  );
};

export default Usage;
